/**
 * @generated SignedSource<<39bd234aefd5c6c41edde8b21b4df56c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoResponseType = "IMAGES" | "NUMBER" | "TEXT";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoDetailList_todoWorkspace$data = {
  readonly archivedAtDate: {
    readonly __typename: "UnzonedDate";
  } | null;
  readonly responseType: TodoResponseType | null;
  readonly todos: ReadonlyArray<{
    readonly commentCount: number;
    readonly id: string;
    readonly resolvedAtDate: {
      readonly isoString: string;
    } | null;
    readonly response: {
      readonly __typename: "TodoResponseImage";
      readonly images: ReadonlyArray<{
        readonly id: string;
      }>;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
    readonly store: {
      readonly name: string;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoStoresGalleryItem_todo" | "WorkspaceTodoStoresListItem_todo">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoListHeader_todoWorkspace">;
  readonly " $fragmentType": "WorkspaceTodoDetailList_todoWorkspace";
};
export type WorkspaceTodoDetailList_todoWorkspace$key = {
  readonly " $data"?: WorkspaceTodoDetailList_todoWorkspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoDetailList_todoWorkspace">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "workspaceId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceTodoDetailList_todoWorkspace",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceTodoListHeader_todoWorkspace"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UnzonedDate",
      "kind": "LinkedField",
      "name": "archivedAtDate",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "responseType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "workspaceId",
          "variableName": "workspaceId"
        }
      ],
      "concreteType": "Todo",
      "kind": "LinkedField",
      "name": "todos",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Store",
          "kind": "LinkedField",
          "name": "store",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "commentCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "StoreZonedDate",
          "kind": "LinkedField",
          "name": "resolvedAtDate",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isoString",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "response",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Image",
                  "kind": "LinkedField",
                  "name": "images",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "type": "TodoResponseImage",
              "abstractKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WorkspaceTodoStoresGalleryItem_todo"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WorkspaceTodoStoresListItem_todo"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TodoWorkspace",
  "abstractKey": null
};
})();

(node as any).hash = "561af4fd166b0cb47b47535d0fa63237";

export default node;
